import { useEffect } from "react";
import Footerr from "../components/Footerr/Footerr";
import LatestBlog from "../components/LatestBlog/LatestBlog";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

function BlogPage() {
  usePageMeta({
    title: "Restaurant Industry Insights & Blog | Terces Solutions",
    description:
      "Practical insights on restaurant operations, menu engineering, cloud kitchens, and F&B growth from the Terces Solutions consulting team.",
    path: "/Blogs",
  });

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="blog-page">
      <Header />
      <main className="blog-content">
        <LatestBlog />
      </main>
      <Footerr />
    </div>
  );
}

export default BlogPage;
